export default __webpack_public_path__ + "static/media/homeLW.643a6d50.svg";